import { FormProvider, useForm } from "react-hook-form";
import { Input, InputError, notify } from "../../utils";
import { setCounselingPhoneNumber } from "../../../api/MoadianService";
import { useState } from "react";
import { positiveNotify } from "../../utils/Notify";

const CounselingPhone = () => {

    const [isSubmitted, setIsSubmitted] = useState(false);
    const methods = useForm();
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm()

    const onSubmit = (data => {
        setCounselingPhoneNumber(data).then(response => {
            if (response.data.errorCode === 'OK') {
                setIsSubmitted(false)
                positiveNotify("شماره شما با موفقیت ثبت شد. همکاران ما جهت راهنمایی با این شماره با شما تماس خواهند گرفت.")
            }
        }).catch(error => {
                notify(error?.response?.data?.message)
                setIsSubmitted(false)
            })
    })

    return (
        <>

            <FormProvider {...methods}>
                <form
                    onSubmit={handleSubmit(onSubmit)}
                    noValidate
                    className="container"
                >
                    <div class="counseling-container">
                        <input
                            type="text"
                            name="phoneNumber"
                            placeholder="شماره موبایل خود را وارد کنید."
                            {...register("phoneNumber", {
                                required: {
                                    value: true,
                                    message: 'لطفا برای دریافت مشاوره شماره موبایل خود را وارد کنید.',
                                },
                                pattern: {
                                    value: /^(09)([0-9]){9}$/i,
                                    message: 'شماره موبایل شما صحیح نیست.'
                                },
                            })}
                        />


                        <button
                            className="counseling-btn"
                            type="submit"
                        >ثبت
                        </button>
                    </div>

                    {errors.phoneNumber && <InputError show={!!errors.phoneNumber} message={errors.phoneNumber.message} />}

                </form>
            </FormProvider>

            {isSubmitted && (
                <div className="loading-overlay">
                    <div className="loading-content">
                        <div className="spinner"></div>
                        <p className='loader-text mt-3'>لطفا چند لحظه منتظر بمانید</p>
                    </div>
                </div>
            )}
        </>
    )
}

export default CounselingPhone